/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */
import type { CarePlanFollowUp } from "./CarePlanFollowUp";
import type { CarePlanLabOrder } from "./CarePlanLabOrder";
import type { CarePlanMedication } from "./CarePlanMedication";

export interface CarePlanContentOutput {
  diagnosis: string;
  created: string;
  medications?: CarePlanMedication[] | null;
  lab_orders?: CarePlanLabOrder[] | null;
  recommendations?: string[] | null;
  follow_up?: CarePlanFollowUp | null;
}
